import { render, staticRenderFns } from "./TaskList/TaskList.html?vue&type=template&id=01a4a4cc&scoped=true&external"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"
import style0 from "./TaskList/TaskList.scss?vue&type=style&index=0&id=01a4a4cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4a4cc",
  null
  
)

export default component.exports